import { useFirebase } from 'containers/FirebaseContext';
import {
  collection,
  doc as firestoreDoc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore';
import {captureException} from '@sentry/react';

export const useQuotes = () => {
  const { firestore } = useFirebase();

  const listenQuotes = (keyID, callback) => {
    if (!keyID) {
      return () => {};
    }
    const collectionRef = collection(firestore, 'quotes');
    const q = query(collectionRef, where('id', '==', keyID));

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const sharableData = {};
        querySnapshot.forEach((doc) => {
          sharableData[doc.id] = doc.data();
        });
        callback(sharableData);
      },
      (error) => {
        if (error.code === 'permission-denied') {
          console.warn("Permission denied for quotes collection. User may not be properly authenticated.");
          return;
        }
        captureException(`659 Error listening to session changes: ${error}`);
        console.error('Error listening to session changes:', error);
      },
    );

    return unsubscribe;
  };

  const createQuotes = async (sentenceData, generated_id) => {
    try {
      const docRef = firestoreDoc(firestore, 'quotes', generated_id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        await updateDoc(docRef, sentenceData);
      } else {
        await setDoc(docRef, sentenceData);
      }
      return;
    } catch (error) {
      console.log(error, 'error');
    }
  };

  const updateQuotes = async (docId, updatedData) => {
    try {
      const docRef = firestoreDoc(firestore, 'quotes', docId);
      await updateDoc(docRef, updatedData);
      console.log(`Quote with ID ${docId} successfully updated!`);
      return { success: true };
    } catch (error) {
      console.error('Error updating quote: ', error);
      captureException(`Error updating quote: ${error}`);
      return { success: false, error };
    }
  };

  const saveConvertedQuotesToFirebase = async (id, currentUser,data) => {
    try {
      const payload = {
        id: id,
        created_at: new Date(),
        user: { role: currentUser.role, id: currentUser.id },
        data: JSON.stringify(data),
      };

      await createQuotes(payload, id);
      console.log('Quotes saved successfully to Firebase');
    } catch (error) {
      console.error('Error saving quotes to Firebase:', error);
    }
  };
  return {
    saveConvertedQuotesToFirebase,
    updateQuotes,
    createQuotes,
    listenQuotes,
  };
};